import { render, staticRenderFns } from "./ParceriasEdit.vue?vue&type=template&id=ff26302a&scoped=true"
import script from "./ParceriasEdit.vue?vue&type=script&lang=js"
export * from "./ParceriasEdit.vue?vue&type=script&lang=js"
import style0 from "./ParceriasEdit.vue?vue&type=style&index=0&id=ff26302a&prod&scoped=true&lang=css"
import style1 from "./ParceriasEdit.vue?vue&type=style&index=1&id=ff26302a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff26302a",
  null
  
)

export default component.exports